<template>
  <div>
    <b-navbar toggleable="lg" type="dark" variant="primary">
      <b-navbar-brand :to="{name: 'Home'}">Boncarbon</b-navbar-brand>

      <b-navbar-toggle target="nav_collapse" />

      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav>
          <b-nav-item :to="{name:'Routes'}">Rutas</b-nav-item>
          <b-nav-item :to="{name:'Clients'}">Clientes</b-nav-item>
          <b-nav-item :to="{name:'Products'}">Productos</b-nav-item>
          <b-nav-item :to="{name:'Employees'}">Empleados</b-nav-item>
          <b-nav-item :to="{name:'Vehicles'}">Vehículos</b-nav-item>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <!--<b-nav-form>
            <b-form-input size="sm" class="mr-sm-2" type="text" placeholder="Search" />
            <b-button size="sm" class="my-2 my-sm-0" type="submit">Search</b-button>
          </b-nav-form>-->

          <!--<b-nav-item-dropdown text="Lang" right>
            <b-dropdown-item href="#">EN</b-dropdown-item>
            <b-dropdown-item href="#">ES</b-dropdown-item>
            <b-dropdown-item href="#">RU</b-dropdown-item>
            <b-dropdown-item href="#">FA</b-dropdown-item>
          </b-nav-item-dropdown>-->

          <b-nav-item-dropdown right>
            <!-- Using button-content slot -->
            <template slot="button-content"><em>Usuario</em></template>
            <b-dropdown-item href="#">Perfil</b-dropdown-item>
            <b-dropdown-item @click="userSignOut">Salir</b-dropdown-item>
          </b-nav-item-dropdown>

        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'NavBar',
  methods: {
    ...mapActions(['userSignOut'])
  }
}
</script>

<style scoped>

</style>
